/**
 * Created by Jie Gao on 2018-11-09.
 */

import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {Plus2SpinsView} from "./Plus2SpinsView";

export class Plus2Spins extends WinPresentationController {
    private _timeline:TimelineLite | null;
    private _view:Plus2SpinsView;
    private _hasWin:boolean;
    private _freespinsLeft:number;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "Plus2Spins", skippable : false});
        this._view = new Plus2SpinsView();
    }

    protected hasWin():boolean {
        return this._hasWin;
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._hasWin = (data.addedNumberOfFreespinsThisSpin === 2);
        this._freespinsLeft = data.freespinsLeft;
    }

    protected startWinPresentation():void {
        this._timeline = new TimelineLite();
        this._timeline.add(this._view.show(this._freespinsLeft));

        this._timeline.add(() => {this.finish();});
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted && this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
        }
        this._timeline = null;
        this._view.hide();
    }
}